import React, { useEffect } from 'react';
import { ROUTE } from 'client_react/booking/common';
import { useClientBookingExperience } from './ClientBookingExperience';
import ConfirmationContent from './components/ConfirmationContent';

const ConfirmationPage = () => {
    const { bookingSession, bookingSessionType, contract, isPending, navigateWithSession } =
        useClientBookingExperience();

    useEffect(() => {
        if (isPending) {
            return;
        }

        if (!bookingSession) {
            navigateWithSession(ROUTE.DATE_AND_TIME);
        } else if (bookingSession.isIncomplete) {
            navigateWithSession(ROUTE.CONTACT_INFORMATION);
        }
    }, [bookingSession, isPending, navigateWithSession]);

    const handleViewContract = () => {
        navigateWithSession(ROUTE.CONTRACT_CONFIRMATION);
    };

    if (!bookingSession && !bookingSessionType) {
        return null;
    }

    return (
        <ConfirmationContent
            bookingSession={bookingSession}
            bookingSessionType={bookingSessionType}
            showSubtitle
            contract={contract}
            onViewContract={handleViewContract}
        />
    );
};

export default ConfirmationPage;
